<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="m9.878 12 6.365-6.364a1 1 0 0 0-1.414-1.414l-7.072 7.071a1 1 0 0 0 0 1.414l7.072 7.071a1 1 0 0 0 1.414-1.414L9.878 12z" />
    </svg>
</template>

<script setup />
